import { apiRequest } from "../../lib/api";

export interface LoginPayload {
  email: string;
  password: string;
}

export interface UsuarioRead {
  id: number;
  empresa_id: number;
  username: string;
  nombre: string;
  email: string;
  /** Code del rol (canónico o propio del comité), no un set fijo. */
  role: string;
  cargo: string | null;
  is_active: boolean;
  is_superadmin: boolean;
  created_at: string;
  updated_at: string;
}

export interface TokenResponse {
  access_token: string;
  token_type: "bearer";
  user: UsuarioRead;
}

export interface EmpresaRead {
  id: number;
  nombre: string;
  rut: string;
  email: string;
  direccion: string | null;
  telefono: string | null;
  giro: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export function loginRequest(payload: LoginPayload): Promise<TokenResponse> {
  return apiRequest<TokenResponse>("/api/v1/auth/login", {
    method: "POST",
    body: payload,
  });
}

/** Cambia la clave del usuario autenticado verificando la actual (204). */
export function cambiarMiClave(
  passwordActual: string,
  passwordNueva: string,
): Promise<void> {
  return apiRequest<void>("/api/v1/me/password", {
    method: "POST",
    body: { password_actual: passwordActual, password_nueva: passwordNueva },
  });
}

export function getMe(): Promise<UsuarioRead> {
  return apiRequest<UsuarioRead>("/api/v1/me");
}

export function getMiEmpresa(): Promise<EmpresaRead> {
  return apiRequest<EmpresaRead>("/api/v1/me/empresa");
}

/** Un comité al que el usuario puede entrar (el suyo o uno con acceso de oficina). */
export interface ComiteDisponible {
  empresa_id: number;
  nombre: string;
  role: string;
  es_origen: boolean;
}

export function listarMisComites(): Promise<ComiteDisponible[]> {
  return apiRequest<ComiteDisponible[]>("/api/v1/me/comites");
}

/** Emite un JWT del comité destino (hay que reemplazar la sesión con él). */
export function cambiarComite(empresaId: number): Promise<{ access_token: string }> {
  return apiRequest<{ access_token: string }>("/api/v1/me/cambiar-comite", {
    method: "POST",
    body: { empresa_id: empresaId },
  });
}

